const C = require("../constants");

const productDialog = (data) => {
    return {
        type: C.PRODUCT_DIALOG,
        data
    }
};

export {productDialog};


// WEBPACK FOOTER //
// ./src/actions/ProductDialogActions.js